import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL } from '../config/env';

export { API_BASE_URL };

// Legacy v1 axios instance — kept for setAuthToken compatibility during v2 migration.
const apiClient: AxiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Sets/clears auth token on the legacy v1 axios instance.
export const setAuthToken = (token: string | null) => {
    if (token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete apiClient.defaults.headers.common['Authorization'];
    }
};
